<!-- 多选框 -->
<template>
  <div>
    <div v-if="mode === 'DESIGN'">
      <el-input v-if="!expanding" class="max-width  disabled-box" suffix-icon="el-icon-arrow-down" size="small" :placeholder="placeholder"></el-input>
      <el-checkbox-group v-else v-model="_value" class="checkbox-group disabled-box">
        <el-checkbox v-for="(op, index) in options" :key="index" :label="op">{{op}}</el-checkbox>
      </el-checkbox-group>
    </div>
    <div v-else>
      <template v-if="!readerMode || perm==='E'">
        <el-select v-if="!expanding" v-model="_value" multiple size="small" clearable :placeholder="placeholder" :disabled="perm==='R'">
          <el-option v-for="(op, index) in options" :key="index" :value="op" :label="op"></el-option>
        </el-select>
        <el-checkbox-group v-else v-model="_value" :disabled="perm==='R'"  class="checkbox-group">
          <el-checkbox v-for="(op, index) in options" :key="index" :label="op">{{op}}</el-checkbox>
        </el-checkbox-group>
      </template>
      <template v-else>
        <div class="form-item-text">{{ readerValue }}</div>
        <!-- <el-select class="max-fill" v-if="!expanding" v-model="_value" multiple size="small" clearable :placeholder="placeholder" disabled>
          <el-option v-for="(op, index) in options" :key="index" :value="op" :label="op"></el-option>
        </el-select>
        <el-checkbox-group v-else v-model="_value" disabled>
          <el-checkbox v-for="(op, index) in options" :key="index" :label="op">{{op}}</el-checkbox>
        </el-checkbox-group> -->
      </template>
    </div>
  </div>
</template>

<script>
import componentMinxins from '../ComponentMinxins'

export default {
  mixins: [componentMinxins],
  name: "MultipleSelect",
  components: {},
  props:{
    placeholder:{
      type: String,
      default: '请选择选项'
    },
    value:{
      type: Array,
      default: () => {
        return []
      }
    },
    expanding:{
      type: Boolean,
      default: false
    },
    options:{
      type: Array,
      default: () => {
        return []
      }
    },
    readerMode: {
      type: Boolean,
      default: false,
    },
  },
  computed:{
    readerValue() {
      return this.value.join("、")
    }
  },
  data() {
    return {
      checks:[]
    }
  },
  methods: {}
}
</script>

<style scoped lang="scss">
.max-width{
  max-width: 208px;
}
.disabled-box{    
  margin-bottom: 4px;
  /deep/.el-checkbox__inner{
    border-color: #DCDFE6;
  }
}
.checkbox-group{
  font-size: 0;
  display: inline-block;
  line-height: 1;
  vertical-align: middle;
  /deep/.el-checkbox{
    padding-top: 2px;
    padding-bottom: 2px;
  }
}
</style>
